import { useShallow } from 'zustand/react/shallow';
import { useMemo } from 'react';
import { useUserStore } from 'common-state';
import { selectUserDetails } from 'common-state/src/stores/userStore';
import { globals } from 'common-ui';

export const UK_CHECK_OUT_REDIRECT = '/jsp/checkout/uk/checkout.jsp#/shipping';
export const US_CHECK_OUT_REDIRECT = '/jsp/checkout/us/index.jsp';
export const APAC_CHECK_OUT_REDIRECT = '/jsp/checkout/au/common/checkout/index.jsp';
export const LOGIN_REDIRECT = '/jsp/curity/login.jsp?checkout=true';
export const NEW_CHECKOUT_REDIRECT = '/checkout';

/**
 * Returns the checkout redirect URL based on the user's login type and country.
 *
 * @return {string} The checkout redirect URL.
 */
export const useCheckoutRedirect = (): string => {
  const { loginType } = useUserStore(useShallow(selectUserDetails)) ?? {};
  const { country } = globals;

  return useMemo(() => {
    if (globals.enableNewCheckout === 'true') {
      if (loginType === 'hard_logged') {
        return NEW_CHECKOUT_REDIRECT;
      }
      return `${LOGIN_REDIRECT}&isNewCheckout=true`;
    }
    if (loginType === 'hard_logged') {
      switch (country) {
        case 'us':
          return US_CHECK_OUT_REDIRECT;
        case 'uk':
          return UK_CHECK_OUT_REDIRECT;
        case 'au':
          return APAC_CHECK_OUT_REDIRECT;
        default:
          return LOGIN_REDIRECT;
      }
    }
    return LOGIN_REDIRECT;
  }, [loginType, country]);
};
